import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";

export const useDashboard = () => {
  const [todayBookingCount, setTodayBookingCount] = useState(0);
  const [todayRevenue, setTodayRevenue] = useState(0);
  const [todayCancelledBookings, setTodayCancelledBookings] = useState(0);
  const [todayADR, setTodayADR] = useState(0);
  const [arrivalList, setArrivalList] = useState([]);
  const [overbookedRooms, setOverbookedRooms] = useState([]);
  const [todayStayRevenue, setTodayStayRevenue] = useState(0);
  const [todayStayRoomNight, setTodayStayRoomNight] = useState(0);
  const [todayStayADR, setTodayStayADR] = useState(0);

  const [todayTotalDays, setTodayTotalDays] = useState(0);

  useEffect(() => {
    if (todayStayRevenue > 0 && todayStayRoomNight > 0) {
      setTodayStayADR((todayStayRevenue / todayStayRoomNight).toFixed(2));
    } else {
      setTodayStayADR(0);
    }
  }, [todayStayRevenue, todayStayRoomNight]);

  useEffect(() => {
    const calculateADR = () => {
      if (todayRevenue > 0 && todayTotalDays > 0) {
        setTodayADR((todayRevenue / todayTotalDays).toFixed(2));
      } else {
        setTodayADR(0);
      }
    };
    const fetchData = async () => {
      try {
        // We want "DD-MM-YYYY"
        const today = moment().format("DD-MM-YYYY");
        const [
          responstFetchTodayBookings,
          responseFetchTodayRevenue,
          responseFetchTodayCancelledBookings,
          responseFetchArrivalList,
        ] = await Promise.all([
          axios.get("/api/bookings/booktoday"),
          axios.get("/api/bookings/chart/todayrevenue"),
          axios.get("/api/bookings/chart/todaycancelled"),
          axios.get(`/api/bookings/arrival/${today}`),
        ]);

        setTodayBookingCount(responstFetchTodayBookings.data.count);
        setTodayRevenue(responseFetchTodayRevenue.data.totalRevenue);
        setTodayCancelledBookings(
          responseFetchTodayCancelledBookings.data.cancelledCount
        );
        setArrivalList(responseFetchArrivalList.data);
      } catch (error) {
        console.error("Error fetching today data:", error);
      }
    };
    fetchData();
    calculateADR();
  }, [todayRevenue, todayTotalDays]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          responseFetchTodayBookedRoomNight,
          responseFetchTodayStayRevenue,
          responseFetchTodayStayRoomNight,
          responseFetchOverbookedStatus,
        ] = await Promise.all([
          axios.get("/api/bookings/chart/todayroomnight"),
          axios.get("/api/bookings/stay/todayrevenue"),
          axios.get("/api/bookings/stay/todayroomnight"),
          axios.get("/api/rooms/overbooked-status"),
        ]);
        setTodayTotalDays(
          responseFetchTodayBookedRoomNight.data.totalBookedRoomNights
        );
        setTodayStayRevenue(
          responseFetchTodayStayRevenue.data.totalStayRevenue
        );
        setTodayStayRoomNight(
          responseFetchTodayStayRoomNight.data.totalStayRoomNights
        );
        setOverbookedRooms(responseFetchOverbookedStatus.data);
      } catch (error) {
        console.error(
          "Error fetching today's booked room night, today's stay revenue, today's stay room night, overbooked status:",
          error
        );
      }
    };
    fetchData();
  }, []);

  return {
    todayBookingCount,
    todayCancelledBookings,
    todayADR,
    arrivalList,
    overbookedRooms,
    todayStayADR,
    todayTotalDays,
    todayStayRoomNight,
    todayRevenue,
    todayStayRevenue,
  };
};
